export const randomInt = (min, max) => Math.floor(Math.random()*(max-min+1)+min);

export const bytesToSize = (bytes) => {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    if ( bytes > 1000000000000 )
        return (bytes / 1000000000000).toFixed(2) + " " + sizes[4];
    else if ( bytes > 1000000000 )
        return (bytes / 1000000000).toFixed(2) + " " + sizes[3];
    else if (bytes > 1000000)
        return (bytes / 1000000).toFixed(0) + " " + sizes[2];
    else if (bytes > 1000)
        return (bytes / 1000).toFixed(0) + " " + sizes[1];
    else
        return bytes + " " + sizes[0]
};

export const setCookie = (name, value, exhours) => {
    var expires = "";
    if (exhours) {
        var date = new Date();
        date.setTime(date.getTime() + (exhours *60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/;" + " Secure;";
    return true;
};

export const deleteAllCookies = () => {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    return cookies;
};

// Clear all local storage items except the items we need to persist
export const clearLocalStorage = () => {

    let persist = [
        'persistent_profile_mode',
        'prefer_local_cursor',
        'report_delta',
        'collapseUsage',
        'collapseUser',
        'collapseAgents',
        'joined_kasms',
        'login_logo',
        'login_caption',
        'header_logo',
        'html_title',
        'favicon_logo'
    ];

    let cached_values = {};

    for (let i = 0; i < persist.length; i++) {
        let t = window.localStorage.getItem(persist[i]);
        if (t) {
            cached_values[persist[i]] = t;
        }
    }

    window.localStorage.clear();

    for (var x in cached_values){
        window.localStorage.setItem(x, cached_values[x]);
    }


};

export const fuzzySearch = (filter, row) =>  {
    // Some values are null so we cast them to an empty string
    let id =  row[filter.id];
    if (id === undefined || id === null){
        id = '';
    }
    id = id.toString().toLowerCase();
    return id.includes(filter.value.toLowerCase())
};


// WEBPACK FOOTER //
// ./src/utils/helpers.js